export default "__VITE_ASSET__BgrnNJyX__"